module.exports = __webpack_public_path__ + "static/halberd-d1b129b05b90edd6ce0637b0180fbf10.jpg";